module.exports = __webpack_public_path__ + "img/account-new-icon3.185253a0.svg";